import { updatePaymentTypes } from '@engine/features/virtual_terminal/vt_update_payment_types';

function updateCashPaymentTypes(paymentTypes) {
  updatePaymentTypes(paymentTypes, 'cash');
}

export default {
  updatePaymentTypes: updateCashPaymentTypes
};